module.exports = __webpack_public_path__ + "img/laine-helesinine.5b135c2f.svg";